var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenant[0] && _vm.tenant[0].status)?_c('div',[(_vm.tenant[0] && _vm.tenant[0].status && _vm.tenant[0].status == 'Ativo')?_c('list-component',{ref:"list_component",attrs:{"id":"20231213"}}):_c('suspended-tenant-component')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }